import { config } from '../utils/constants/api.constants';
import { convertObjectToParams } from '../utils/utils';

const { baseUrl, cleaningQa, cleaningHistory, tasks, trainingTutorial, getPreSignedUrl } =
  config.api.carCleaning;

const CAR_CLEANING_HEADERS = {
  ['X_CLIENT_TYPE']: 'PANEL',
};

export default (api) => {
  const fetchCleaningQa = (params) => {
    const url = `${baseUrl}${cleaningQa}${convertObjectToParams(params)}`;
    return api.get(url, {}, CAR_CLEANING_HEADERS);
  };

  const fetchCleaningHistory = (params) => {
    const url = `${baseUrl}${cleaningHistory}${convertObjectToParams(params)}`;
    return api.get(url, {}, CAR_CLEANING_HEADERS);
  };

  const fetchCleaningDetail = (taskId) => {
    const url = `${baseUrl}${tasks}/${taskId}`;
    return api.get(url, {}, CAR_CLEANING_HEADERS);
  };

  const approveCleaningDetail = (taskId, payload) => {
    const url = `${baseUrl}${tasks}/${taskId}/APPROVE`;
    return api.post(url, payload, CAR_CLEANING_HEADERS);
  };

  const assignTaskToMe = (taskId, payload) => {
    const url = `${baseUrl}${tasks}/${taskId}/ASSIGN`;
    return api.post(url, payload, CAR_CLEANING_HEADERS);
  };

  const fetchTrainingTutorials = () => {
    const url = `${baseUrl}${trainingTutorial}`;
    return api.get(url, {}, CAR_CLEANING_HEADERS);
  };

  const fetchPreSignedUrl = (params) => {
    const url = `${baseUrl}${getPreSignedUrl}${convertObjectToParams(params)}`;
    return api.get(url, {}, CAR_CLEANING_HEADERS);
  };

  const saveTrainingTutorial = (payload) => {
    const url = `${baseUrl}${trainingTutorial}`;
    return api.post(url, payload, CAR_CLEANING_HEADERS);
  };

  return {
    fetchCleaningQa,
    fetchCleaningHistory,
    fetchCleaningDetail,
    approveCleaningDetail,
    assignTaskToMe,
    fetchTrainingTutorials,
    saveTrainingTutorial,
    fetchPreSignedUrl,
  };
};
